// --- START OF FILE AnteciparLucro.js ---

import React, { useContext, useEffect, useState } from "react";
import * as S from "./AnteciparLucroStyle";
import Loading from "../Loader";
import axios from "axios";
import { AuthContext } from "../../Context/AuthContext";
import { formatDate, formatNumber } from "../ASSETS/assets";
import { useNavigate } from "react-router-dom";
import { FaTimes } from "react-icons/fa";

const base_route = process.env.REACT_APP_API_BASE_URL;

export default function AnteciparLucro() {
  const { logout, getPurchases, purchases, authState } = useContext(AuthContext);
  const navigate = useNavigate();

  // Estados do componente
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedContract, setSelectedContract] = useState(null);

  // --- ESTADOS REFEITOS PARA A NOVA FUNCIONALIDADE ---
  const [aditionalValue, setAditionalValue] = useState("");
  // NOVO ESTADO: Controla se o input é de valor (R$) ou porcentagem (%)
  const [inputType, setInputType] = useState("value"); // 'value' ou 'percentage'

  // Proteção de rota
  // useEffect(() => {
  //   if (
  //     authState.permission !== "ALL" &&
  //     !authState.permission.includes("ANTECIPAR SALDO")
  //   ) {
  //     navigate("/");
  //   }
  // }, [authState, navigate]);

  // Função para buscar contratos
  const fetchContract = async () => {
    if (!searchTerm) {
      alert("Por favor, digite um nome ou CPF para pesquisar.");
      return;
    }
    setLoading(true);
    try {
      await getPurchases(100, 0, "asc", "", searchTerm);
    } catch (e) {
      console.error("Erro ao buscar contratos:", e);
    } finally {
      setLoading(false);
    }
  };
  
  // Limpa o formulário e a seleção
  const resetForm = () => {
    setSearchTerm("");
    setSelectedContract(null);
    setAditionalValue("");
    setInputType("value");
  };

  // --- FUNÇÃO ATUALIZADA PARA O NOVO ENDPOINT ---
  const handleSendValue = async () => {
    if (!aditionalValue || parseFloat(aditionalValue) <= 0) {
      alert("Por favor, insira um valor válido maior que zero.");
      return;
    }

    setLoading(true);

    const payload = {
      valueToIncrement: parseFloat(aditionalValue),
      isPercentage: inputType === "percentage",
    };

    try {
      // Usando o endpoint correto e o ID do contrato
      const response = await axios.post(
        `${base_route}contract/${selectedContract.contract.id}/antecipate`,
        payload,
        {
          headers: { Authorization: `Bearer ${authState.accessToken}` },
        }
      );

      // Tratamento de sucesso mais robusto
      if (response.status === 200) {
        alert("Lucro antecipado com sucesso!");
        resetForm(); // Limpa tudo após o sucesso
        getPurchases(100, 0, "asc", "", searchTerm); // Atualiza a lista
      }
    } catch (error) {
      if (error.response?.status === 401 || error.response?.status === 403) {
        alert("Sessão Expirada. Por favor, faça login novamente.");
        logout();
      } else {
        // Mostra a mensagem de erro vinda do backend, se existir
        const errorMessage = error.response?.data?.message || error.message;
        alert(`Houve um erro: ${errorMessage}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <S.AnteciparLucroContainer>
      <Loading load={loading} />
      <S.ContentBox>
        <S.Header>
          <h1>Antecipação de Lucro</h1>
        </S.Header>

        <S.Step>
          <h4>1. Pesquise e selecione o contrato</h4>
          <S.ClientSearch>
            <div className="inputBoxFilter">
              <input
                type="text"
                placeholder="NOME OU CPF do cliente"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && fetchContract()}
              />
            </div>
          </S.ClientSearch>
          <S.ButtonSearch>
            <button onClick={fetchContract}>Procurar Contratos</button>
          </S.ButtonSearch>
        </S.Step>

        <S.SearchedClients>
          <div className="columns">
            <span>ID Cont.</span>
            <span>Cliente</span>
            <span>Valor Total</span>
            <span>Data Fim</span>
          </div>
          {selectedContract ? (
            <div className="rowSelected">
              <span>{selectedContract.contract.id}</span>
              <span>{selectedContract.clientName}</span>
              <span>R$ {formatNumber(selectedContract.contract.totalPrice)}</span>
              <span>{formatDate(selectedContract.contract.endContractDate)}</span>
              <button onClick={() => setSelectedContract(null)}>
                <FaTimes />
              </button>
            </div>
          ) : (
            <div className="tabelona">
              {purchases.map((purchase) => (
                <div
                  onClick={() => setSelectedContract(purchase)}
                  className="row"
                  key={purchase.contract.id}
                >
                  <span>{purchase.contract.id}</span>
                  <span>{purchase.clientName}</span>
                  <span>R$ {formatNumber(purchase.contract.totalPrice)}</span>
                  <span>{formatDate(purchase.contract.endContractDate)}</span>
                </div>
              ))}
            </div>
          )}
        </S.SearchedClients>

        {selectedContract && (
          <S.QuandoDeseja>
            <h4>2. Informe o valor da antecipação</h4>
            
            {/* --- NOVA SEÇÃO DE INPUT COM SELETOR DE TIPO --- */}
            <div className="form-grid">
                <div className="input-group">
                    <label>Tipo de Lançamento</label>
                    <S.InputTypeToggle>
                        <button 
                            className={inputType === 'value' ? 'active' : ''}
                            onClick={() => setInputType('value')}
                        >
                            Valor (R$)
                        </button>
                        <button 
                            className={inputType === 'percentage' ? 'active' : ''}
                            onClick={() => setInputType('percentage')}
                        >
                            Porcentagem (%)
                        </button>
                    </S.InputTypeToggle>
                </div>

                <div className="input-group">
                    <label>{inputType === 'value' ? 'Valor a antecipar (R$)' : 'Porcentagem a antecipar (%)'}</label>
                    <input
                        type="number"
                        placeholder={inputType === 'value' ? 'Ex: 500.00' : 'Ex: 10.5'}
                        value={aditionalValue}
                        onChange={(e) => setAditionalValue(e.target.value)}
                    />
                </div>

                <button className="submit-button" onClick={handleSendValue}>
                    Antecipar Valor
                </button>
            </div>
            {/* --- FIM DA NOVA SEÇÃO --- */}

          </S.QuandoDeseja>
        )}
      </S.ContentBox>
    </S.AnteciparLucroContainer>
  );
}